import React, {useState} from "react";
import UnitedKingdomTable from "./UnitedKingdomTable/UnitedKingdomTable";
import Collapse from "@material-ui/core/Collapse";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import {getCardIcon} from "../../../utils/utils"
import { useTranslation } from 'react-i18next';

function UnitedKingdomCard(props) {

    const [expanded, setExpanded]   = useState(false);
    const [firstTime, setFirstTime] = useState(true);
    const { t } = useTranslation()

    const {unitedKingdom}    = props
    let initialExpand   = unitedKingdom.flag === "positive"? false : true

    if (initialExpand !== expanded && firstTime===true){
        setExpanded(initialExpand);
    }

    const handleExpand = (event) => {
        event.stopPropagation();
        setFirstTime(false)
        setExpanded(!expanded);
    };

    return (
        <div className="analysisCard">
            <div style={{display:"flex"}}>
                <div 
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{margin:"auto 0px"}}
                >
                    {t("uk_sanctions_list")}
                </div>
                <div style={{margin:"auto 10px"}}>
                    {getCardIcon(unitedKingdom.flag)}
                </div>
                {unitedKingdom.data.length === 0 ? null :
                <IconButton style={{marginLeft: "auto"}} onClick={handleExpand}>
                    {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </IconButton>             
                }                    
            </div>
            {unitedKingdom.data.length === 0 ? null :
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <div 
                    className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}
                >
                    <UnitedKingdomTable unitedKingdom_data={unitedKingdom.data}/>
                </div>
            </Collapse> 
            }     
        </div>
    );
}

export default UnitedKingdomCard